"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { PanelCornerDots } from "@/app/components/PanelCornerDots";
import emptyFormatGrid from "./empty-format-grid.svg";
import styles from "./EmptyFormatColumn.module.css";

/**
 * Decorative companion column when a course offers a single learning format.
 * Desktop (≥1024) only — LearningFormatDesktop is not rendered below that.
 */
export function EmptyFormatColumn() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.column} aria-hidden={true}><Image src={emptyFormatGrid} alt="" fill={true} unoptimized={true} sizes="(min-width: 1024px) 50vw, 0px" className={styles.grid} /><PanelCornerDots className={styles.dots} /><PanelCornerDots className={styles.dots} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}